/* eslint-disable import/prefer-default-export */
import * as Yup from 'yup';

export const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email Address')
    .required('Please enter your username'),
  lastName: Yup.string().required('Please enter your password')
});
